import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeModal } from '@src/redux/actions/modal';
import { Button } from '@src/components/Button';
import './styles.scss';

const _ConfirmationModal = ({ subTitle, onConfirm, body, footer, closeModal }) => {
  return (
    <div className="confirmation-modal">
      <p className="confirmation-modal__sub-title">{subTitle || 'Are you sure you want to proceed?'}</p>
      {body && <div>{body}</div>}

      <Button
        className="confirmation-modal__confirm"
        onClick={() => {
          closeModal();
          onConfirm();
        }}
      >
        Confirm
      </Button>
      <Button appearance="secondary" className="confirmation-modal__close" onClick={closeModal}>
        Cancel
      </Button>
      {footer && <div>{footer}</div>}
    </div>
  );
};

_ConfirmationModal.propTypes = {
  body: PropTypes.node,
  closeModal: PropTypes.func.isRequired,
  footer: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  subTitle: PropTypes.string,
};

export const ConfirmationModal = connect(null, { closeModal })(_ConfirmationModal);
